// extracted by mini-css-extract-plugin
export var defaultWrapper = "_nk-3";
export var downloadButton = "_nk-4";
export var fileContainer = "_nk-9 _nk-7";
export var fileContainerBase = "_nk-7";
export var fileContainerFixedHeight = "_nk-8 _nk-7";
export var fileInfo = "_nk-5";
export var fileInfoWidthRestricted = "_nk-6";
export var fileType = "_nk-1";
export var fileTypeName = "_nk-2";
export var image = "_nk-0";
export var link = "_nk-b";
export var overflowEllipsis = "_nk-a";